import React from "react";
import './ServiceJourney.css';
import "react-multi-carousel/lib/styles.css";
import CorauselSlider from "../../../utility/components/CorauselSlider";


const TitleComponent = ({ title }) => {
    return (
        <div className="service__title-container">
            <h1>{title}</h1>
        </div>
    );
}

const ServiceJourneyItem = ({ src, alt, steptitle, description }) => {
    const imageSrc = require(`../../../assets/img/${src}`);
    return (
        <div className="service__card-container">
            <div className="image-container">
                <img src={imageSrc} alt={alt} />
            </div>

            <div className="title-container">
                <p>{steptitle}</p>
            </div>

            <div className="description-container">
                <p>{description}</p>
            </div>
        </div>
    )
}

export const ServiceJourney = () => {
    const items = [
        { src: "journey1.jpg", alt: "service image", steptitle: "1. Design Consultation", description: "30-minute virtual session to clarify project goals and design. The discussion will focus on your vision and requirements for a tailored design experience." },
        { src: "journey2.jpg", alt: "service image", steptitle: "2. Schematic Design", description: "Refinement of ideas into a concrete design document, emphasizing spatial layout and color palette to establish a cohesive vision for the project." },
        { src: "journey4.jpg", alt: "service image", steptitle: "3. Design Development", description: "Transformation of concepts into detailed drawings and specifications for materials and furniture ensures all design aspects align with the vision." },
        { src: "journey5.jpg", alt: "service image", steptitle: "4. Construction Documentation", description: "Production of comprehensive drawings and documentation for permits and construction, facilitating a smooth transition from concept to execution." },
        { src: "journey3.jpg", alt: "service image", steptitle: "5. Completion & Handover", description: "Oversight of project execution and collaboration with contractors ensures alignment with the design vision, enabling enjoyment of the crafted space." }
    ];

    return (
        <section className="section-container">
            <TitleComponent title="Service Journey" />
            <CorauselSlider cards={items} renderCard={ServiceJourneyItem} showProgressBar={false} >
                {items.map((item, index) => (
                    <ServiceJourneyItem
                        key={index}
                        src={item.src}
                        alt={item.alt}
                        steptitle={item.steptitle}
                        description={item.description}
                    />
                ))}
            </CorauselSlider>
        </section>
    );
};